var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partners"},[_c('title-info',{attrs:{"nav-info":_vm.navInfo}}),_c('text-info'),_c('exploit-info',{ref:"part_1"}),_c('people-info',{ref:"part_2"}),_c('register-info',{ref:"part_3"}),_c('union-info',{ref:"part_4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }